let target = '.banner-with-below-text .content p span, .image-with-text-new .content p span, .gallery-grid-with-content-two .right-content p span, .gallery-grid-with-content-two .left-content p span, .gallery-grid-with-content-two .content p span, .banner-below-image-with-text .image-with-text .content p span';

const prices = gsap.utils.toArray(target);
// gsap.set(target, {opacity:0.3, transformOrigin:'left center'})
prices.forEach(price => {
gsap.to(price, {
    opacity:1, 
    duration:0.5,
    scrollTrigger: {
    trigger: price,
    start:'top 60%',
    end:'top 30%',
    toggleActions: "play reverse play reverse",
    markers:false
    }
  })
})